import { render } from "./typeDamage.vue?vue&type=template&id=063a1408"
import script from "./typeDamage.vue?vue&type=script&lang=js"
export * from "./typeDamage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__